import DateFnsUtils from "@date-io/date-fns";
import { Checkbox, TableCell, TableRow, TextField } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import { Alteration } from "./Alterations";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Building, Elevator, Mechanic, StaticVariables } from "../StaticVariables";

interface RowProps {
	Data: Alteration;
}

export function AlterationRow(props: RowProps) {
	const insp = props.Data;
	const [building, setBuilding] = React.useState(insp.BuildingID);
	const [elevator, setElevator] = React.useState(insp.ElevatorsID);
	const [mechanic, setMechanic] = React.useState(insp.MechanicID);
	const [company, setCompany] = React.useState(insp.Company);
	const [passed, setPassed] = React.useState(insp.Passed);
	const [secondPassed, setSecondPassed] = React.useState(insp.SecondPassed);
	const [thirdPassed, setThirdPassed] = React.useState(insp.ThirdPassed);
	const [firstDate, setFirstDate] = React.useState(insp.FirstDate);
	const [secondDate, setSecondDate] = React.useState(insp.SecondDate);
	const [thirdDate, setThirdDate] = React.useState(insp.ThirdDate);

	const isPassed = passed || secondPassed || thirdPassed;

	const b = StaticVariables.Buildings.find((x) => x.BuildingsID === building);
	const e = StaticVariables.Elevators.find((x) => x.ElevatorsID === elevator);
	const elevators = StaticVariables.Elevators.filter((x) => building && x.BuildingsID.toLocaleLowerCase() === building.toLocaleLowerCase());
	const m = StaticVariables.Mechanics.find((x) => x.MechanicID === mechanic);
	if (elevators.length === 1 && elevators[0].ElevatorsID !== elevator) setElevator(elevators[0].ElevatorsID);

	return (
		<TableRow>
			<TableCell>
				<Autocomplete
					size="small"
					value={b}
					onChange={(event: any, newValue: any) => {
						setBuilding(newValue.BuildingsID);
						insp.BuildingID = newValue.BuildingsID;
						setElevator(null);
						insp.ElevatorsID = null;
						insp.Modified = true;
					}}
					title={b?.BuildingName}
					disableClearable={true}
					renderInput={(params) => <TextField size="small" {...params} label="" variant="outlined" />}
					options={StaticVariables.Buildings}
					getOptionLabel={(x: Building) => x.BuildingName}
				/>
			</TableCell>
			<TableCell>
				<Autocomplete
					size="small"
					value={e}
					disableClearable={true}
					title={e?.SerialNumber}
					onChange={(event: any, newValue: any) => {
						setElevator(newValue.ElevatorsID);
						insp.ElevatorsID = newValue.ElevatorsID;
						insp.Modified = true;
					}}
					renderInput={(params) => <TextField size="small" {...params} label="" variant="outlined" />}
					options={StaticVariables.Elevators}
					getOptionLabel={(x: Elevator) => x.SerialNumber}
				/>
			</TableCell>
			<TableCell>
				<Autocomplete
					size="small"
					value={m}
					title={m?.Name}
					disableClearable={true}
					onChange={(event: any, newValue: any) => {
						setMechanic(newValue.MechanicID);
						insp.MechanicID = newValue.MechanicID;
						insp.Modified = true;
					}}
					renderInput={(params) => <TextField size="small" {...params} label="" variant="outlined" />}
					options={StaticVariables.Mechanics}
					getOptionLabel={(x: Mechanic) => x.Name}
				/>
			</TableCell>
			<TableCell>
				<TextField
					placeholder="Company"
					value={company}
					onChange={(event) => {
						setCompany(event.target.value);
						insp.Company = event.target.value;
						insp.Modified = true;
					}}></TextField>
			</TableCell>
			<TableCell>
				<Checkbox
					disabled={isPassed || firstDate == null}
					checked={passed}
					onChange={(event, checked) => {
						insp.Passed = checked;
						setPassed(checked);
						insp.Modified = true;
					}}></Checkbox>
			</TableCell>
			<TableCell>
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<KeyboardDatePicker
						size="small"
						disabled={isPassed}
						autoOk
						variant="inline"
						label=""
						format="MM/dd/yyyy"
						value={firstDate}
						onChange={(date) => {
							date.setHours(0);
							date.setMinutes(0);
							date.setSeconds(0);
							date.setMilliseconds(0);
							setFirstDate(date);
							insp.FirstDate = date;
							insp.Modified = true;
						}}
					/>
				</MuiPickersUtilsProvider>
			</TableCell>
			<TableCell>
				<Checkbox
					disabled={isPassed || secondDate == null}
					checked={secondPassed}
					onChange={(event, checked) => {
						insp.SecondPassed = checked;
						setSecondPassed(checked);
						insp.Modified = true;
					}}></Checkbox>
			</TableCell>
			<TableCell>
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<KeyboardDatePicker
						size="small"
						autoOk
						variant="inline"
						disabled={isPassed}
						label=""
						format="MM/dd/yyyy"
						value={secondDate}
						onChange={(date) => {
							date.setHours(0);
							date.setMinutes(0);
							date.setSeconds(0);
							date.setMilliseconds(0);
							setSecondDate(date);
							insp.SecondDate = date;
							insp.Modified = true;
						}}
					/>
				</MuiPickersUtilsProvider>
			</TableCell>
			<TableCell>
				<Checkbox
					disabled={isPassed || thirdDate == null}
					checked={thirdPassed}
					onChange={(event, checked) => {
						insp.ThirdPassed = checked;
						setThirdPassed(checked);
						insp.Modified = true;
					}}></Checkbox>
			</TableCell>
			<TableCell>
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<KeyboardDatePicker
						size="small"
						autoOk
						variant="inline"
						label=""
						disabled={isPassed}
						format="MM/dd/yyyy"
						value={thirdDate}
						onChange={(date) => {
							date.setHours(0);
							date.setMinutes(0);
							date.setSeconds(0);
							date.setMilliseconds(0);
							setThirdDate(date);
							insp.ThirdDate = date;
							insp.Modified = true;
						}}
					/>
				</MuiPickersUtilsProvider>
			</TableCell>
		</TableRow>
	);
}
